// src/store/slices/filterSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DateRange { from: string|null; to: string|null; }

interface FilterState {
  user: string;
  flag: '' | 'green' | 'yellow' | 'red';
  range: DateRange;
}

const initialState: FilterState = {
  user: '',
  flag: '',
  range: { from: null, to: null },
};

const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setUser:  (s, a: PayloadAction<string>)       => { s.user = a.payload; },
    setFlag:  (s, a: PayloadAction<FilterState['flag']>) => { s.flag = a.payload; },
    setRange: (s, a: PayloadAction<DateRange>)    => { s.range = a.payload; },
  },
});

export const { setUser, setFlag, setRange } = filterSlice.actions;
export default filterSlice.reducer;
